import { useEffect, useState } from "react";
import { tw } from "@careinfo/tailwind";
import { useHeaderEditor } from "../../../context/GrapeJsHeaderContext";
import grapesjs from "grapesjs";
import { deviceManager } from "./deviceManage";
import navbarPlugins from "../Plugins/Header";
import Modal from "../../../shared/Modal";
import NavigationPopup from "../NavigationPopup";
import APIS from "../../../constant/Endpoint";
import usePostHook from "../../../hooks/usePostHook";
import useEditor from "../../../hooks/useEditor";
import { API_ROOT, getApiData } from "../../../helpers/AxiosInstance";
import { accessToken } from "../../../helpers/sessionKey";

const HeaderEditor = (props: any) => {
  const { editorHeaderRef, handleDisable } = props;
  const { setEditor: setHeaderEditor, editor } = useHeaderEditor();
  const [openNavbarEditPopup, setNavbarEditPopup] = useState(false);
  const { handleMediaUpload } = useEditor();
  const rootColors = {
    "--primary": "#ef4444",
    "--secondary": "#fea9a9",
  };

  const injectRootVariablesIntoCanvas = (editorInstance) => {
    const canvas = editorInstance.Canvas;
    const iframe = canvas.getFrameEl();

    if (iframe) {
      const iframeDocument =
        iframe.contentDocument || iframe.contentWindow.document;
      const style = iframeDocument.createElement("style");
      style.textContent = `
        :root {
          --primary: ${rootColors["--primary"]};
          --secondary: ${rootColors["--secondary"]};
        }
      `;
      iframeDocument.head.appendChild(style);
    }
  };

  useEffect(() => {
    if (!editorHeaderRef.current) {
      const editorInstance = grapesjs.init({
        container: "#header-container",
        fromElement: true,
        plugins: [...navbarPlugins],
        panels: { defaults: [] },
        height: "120px",
        width: "auto",
        deviceManager: deviceManager,
        canvas: {
          scripts: [
            "https://careinfo-solutions.s3.ap-south-1.amazonaws.com/tailwind/tailwind.min.js",
          ],
        },
        assetManager: {
          assets: [],
          autoAdd: true,
          dropzone: true,
          openAssetsOnDrop: true,
          showUrlInput: true,
          uploadFile: function (ev: any) {
            const files = ev.dataTransfer
              ? ev.dataTransfer.files
              : ev.target.files;
            if (editorHeaderRef.current) {
              handleMediaUpload(files, editorInstance);
            }
          },
        },
        storageManager: {
          type: "remote",
          autosave: false,
          autoload: true,
          stepsBeforeSave: 1,
          options: {
            remote: {
              headers: {
                "Content-Type": "application/json",
                Authorization: `JWT ${accessToken()}`,
              },
              urlLoad: `${API_ROOT}${APIS.HEADER}`,
            },
          },
        },
        blockManager: {
          appendTo: "#header-blocks",
        },
        traitManager: {
          appendTo: "#header-trait",
        },
        styleManager: {
          appendTo: "#header-style",
        },
        selectorManager: {
          appendTo: "#header-selector",
        },
      });
      editorInstance.on("load", () => {
        injectRootVariablesIntoCanvas(editorInstance);
      });
      setHeaderEditor(editorInstance);
      editorHeaderRef.current = editorInstance;
    }
    return () => {
      if (editorHeaderRef.current) {
        editorHeaderRef.current.destroy();
        editorHeaderRef.current = null;
      }
    };
  }, []);

  editor?.Commands.add("navbar-edit", {
    run(editor, sender, opts) {
      setNavbarEditPopup(!openNavbarEditPopup);
    },
  });

  const { mutateAsync, isLoading } = usePostHook({
    queryKey: ["navigation"],
  });

  const handleCreate = async (values: any, setError: any, setIsOpen) => {
    const formData = {
      ...values,
      pages: values?.pages.id,
      is_external: values?.is_external ?? false,
      is_redirect: values?.is_redirect ?? false,
    };
    const url = APIS.NAVIGATION;
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setIsOpen(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <style>{`
        :root {
          --primary:rgba(250, 7, 7, 0);
          --secondary: rgba(0, 0, 0, 0.1);
        }
      `}</style>
      <header
        id="header-container"
        className={tw`my-1 shadow`}
        onMouseEnter={() => handleDisable("header")}
      ></header>
      <Modal
        title="Navigation Menu"
        isOpen={openNavbarEditPopup}
        setIsOpen={setNavbarEditPopup}
      >
        <NavigationPopup handleCreate={handleCreate} isLoading={isLoading} />
      </Modal>
    </>
  );
};

export default HeaderEditor;
